import { useEffect, useState } from 'react'
import { client } from './prismic-configuration'

export const usePrismicClient = (): any => client

export const usePrismicDocumentByUID = (type: string, uid?: string): [any] => {
  const [document, setDocument] = useState<any>(null)

  useEffect(() => {
    if (!uid) {
      setDocument(null)
      return
    }

    let isMounted = true

    client.getByUID(type, uid).then((result: any) => {
      if (isMounted) {
        setDocument(result)
      }
    }).catch(() => {
      if (isMounted) {
        setDocument(null)
      }
    })

    return () => {
      isMounted = false
    }
  }, [type, uid])

  return [document]
}

export const useSinglePrismicDocument = (type: string): [any] => {
  const [document, setDocument] = useState<any>(null)

  useEffect(() => {
    let isMounted = true

    client.getSingle(type).then((result: any) => {
      if (isMounted) {
        setDocument(result)
      }
    }).catch(() => {
      if (isMounted) {
        setDocument(null)
      }
    })

    return () => {
      isMounted = false
    }
  }, [type])

  return [document]
}